export const ComparablesPaths = {
  ANY: '/comparables/',
  COMPANY: '/comparables/company',
  MARKET: '/comparables/market',
  SECTOR: '/comparables/sector',
  MOVERS: '/comparables/movers',
} as const

export const DealConnectPaths = {
  ROOT: '/dealconnect',
  EXPLORER: '/dealconnect/explorer',
  DOCUMENTS: '/dealconnect/documents',
} as const

export const dealConnectExplorerDealPath = (datasite: string, dealId: string) =>
  `${DealConnectPaths.EXPLORER}/${datasite}/${dealId}`

export type ComparablesPathValue = (typeof ComparablesPaths)[keyof typeof ComparablesPaths]
